import dark from './dark.scss'
import light from './light.scss'
import darkSide from './dark-side.scss'
export default {
  dark,
  light,
  'dark-side': darkSide
}
